import { useEffect } from 'react';
import LegalLayout from '../components/legal/LegalLayout.jsx';
import { setPageMetadata } from '../utils/seo.js';

const TERMS_SECTIONS = [
	{ id: 'resumen-rapido', label: 'Resumen rapido' },
	{ id: 'uso-del-sitio', label: 'Uso del sitio' },
	{ id: 'propiedad-intelectual', label: 'Propiedad intelectual' },
	{ id: 'limitacion-responsabilidad', label: 'Limitacion de responsabilidad' },
	{ id: 'contacto-legal', label: 'Contacto' },
];

function TermsPage() {
	useEffect(() => {
		setPageMetadata({
			title: 'Terminos y Condiciones | CodingFlash',
			description:
				'Lee los terminos y condiciones para usar el sitio y los servicios de desarrollo web y software a medida de CodingFlash.',
			path: '/terminos',
		});
	}, []);

	return (
		<LegalLayout
			title='Terminos y Condiciones'
			description='Al acceder y usar este sitio aceptas estos terminos. Si no estas de acuerdo, te pedimos no utilizarlo.'
			updatedAt='2026-02-19'
			sections={TERMS_SECTIONS}
		>
			<section
				id='resumen-rapido'
				className='rounded-xl border border-white/10 bg-white/[0.02] p-5 sm:p-6'
			>
				<h2 className='mb-3 text-lg font-semibold text-primary sm:text-xl'>
					Resumen rapido
				</h2>
				<ul className='list-disc space-y-2.5 pl-5 text-sm leading-relaxed sm:text-base'>
					<li>Podes usar el contenido para informarte y evaluar servicios.</li>
					<li>No se permite uso fraudulento ni copia sin autorizacion.</li>
					<li>
						Podemos actualizar el sitio y estos terminos cuando sea necesario.
					</li>
				</ul>
			</section>

			<section
				id='uso-del-sitio'
				className='rounded-xl border border-white/10 bg-white/[0.02] p-5 sm:p-6'
			>
				<h2 className='mb-3 text-lg font-semibold text-primary sm:text-xl'>
					Uso del sitio
				</h2>
				<ul className='list-disc space-y-2.5 pl-5 text-sm leading-relaxed sm:text-base'>
					<li>El contenido tiene fines informativos y comerciales.</li>
					<li>No se permite uso abusivo ni contrario a la ley.</li>
					<li>
						Podemos actualizar contenidos o funcionalidades sin aviso previo.
					</li>
				</ul>
			</section>

			<section
				id='propiedad-intelectual'
				className='rounded-xl border border-white/10 bg-white/[0.02] p-5 sm:p-6'
			>
				<h2 className='mb-3 text-lg font-semibold text-primary sm:text-xl'>
					Propiedad intelectual
				</h2>
				<p className='text-sm leading-relaxed sm:text-base'>
					Marcas, disenos, textos, codigo e imagenes del sitio pertenecen a
					CodingFlash o a sus respectivos titulares y no pueden reproducirse sin
					autorizacion escrita.
				</p>
			</section>

			<section
				id='limitacion-responsabilidad'
				className='rounded-xl border border-white/10 bg-white/[0.02] p-5 sm:p-6'
			>
				<h2 className='mb-3 text-lg font-semibold text-primary sm:text-xl'>
					Limitacion de responsabilidad
				</h2>
				<p className='text-sm leading-relaxed sm:text-base'>
					Hacemos esfuerzos razonables para mantener la informacion actualizada,
					pero no garantizamos ausencia total de errores o interrupciones del
					servicio.
				</p>
			</section>

			<section
				id='contacto-legal'
				className='rounded-xl border border-white/10 bg-white/[0.02] p-5 sm:p-6'
			>
				<h2 className='mb-3 text-lg font-semibold text-primary sm:text-xl'>
					Contacto
				</h2>
				<p className='text-sm leading-relaxed sm:text-base'>
					Para consultas legales o comerciales escribinos a{' '}
					<a
						href='mailto:codingflash.agency@gmail.com'
						className='inline-block max-w-full break-words text-primary underline decoration-white/30 underline-offset-4 transition-colors hover:decoration-primary [overflow-wrap:anywhere]'
					>
						codingflash.agency@gmail.com
					</a>
					.
				</p>
			</section>
		</LegalLayout>
	);
}

export default TermsPage;
